export default function (data: string): any {
  try {
    return JSON.parse(data)
  } catch (ex) {
    return {}
  }
}
